module.exports = __webpack_public_path__ + "img/icon-passport-avatar.e8b185c7.svg";